import PageViewer from "@/components/PageViewer";
import PERMISSIONS from "@/common/permissions-lib";

export default {
	path: "/TFlowRestriction",
	meta: {
		breadcrumb: "TFlowRestriction",
		authorizedRoles: [
			PERMISSIONS.MOT_EDIT,
			PERMISSIONS.MOT_VIEW,
			PERMISSIONS.MOT_APPROVE,
			PERMISSIONS.TFR_EDIT,
			PERMISSIONS.TFR_VIEW
		]
	},
	component: PageViewer,
	props: { pageTransition: "none" },
	children: [
		{
			path: "/TFlowRestriction",
			name: "TFlowRestriction",
			props: { pageTransition: "none" },
			component: () =>
				import(
					/* webpackChunkName: "TFlowRestriction" */ "@/views/TFlowRestriction/TFlowRestrictionMain"
				)
		},
		{
			path:
				"/TFlowRestriction/:projectId/:region/:county/:localOffice/:clientId/:contractorId/:fromDate/:toDate/:byUser/:type/:showWithoutRules/:status",
			name: "TFlowRestriction.Filter",
			props: route => {
				return {
					projectId: route.params.ProjectId,
					region: route.params.Region,
					county: route.params.County,
					localOffice: route.params.LocalOffice,
					clientId: route.params.ClientId,
					contractorId: route.params.ContractorId,
					fromDate: route.params.FromDate,
					toDate: route.params.ToDate,
					byUser: route.params.ByUser,
					showWithoutRules: route.params.ShowWithoutRuleSet,
					type: route.params.ProjectType,
					status: route.params.ProjectStatus
				};
			},
			meta: {},
			component: () =>
				import(
					/* webpackChunkName: "MOT.motId" */ "@/views/TFlowRestriction/TFlowRestrictionMain"
				)
		},
		{
			path: "/MOT/:projectId/:motId",
			name: "MOT",
			props: route => {
				return {
					projectId: route.params.projectId,
					motId: route.params.motId
				};
			},
			meta: {
				breadcrumb() {
					return (
						`TFR ` +
						this.$mhi.replaceLabel("Rule Set") +
						`#:` +
						this.$route.params.motId
					);
				}
			},
			component: () =>
				import(/* webpackChunkName: "MOT.motId" */ "@/views/MOT/MOTMain")
		},
		{
			path: "/MOT/:motId?",
			name: "MOT.bymotId_New",
			props: route => ({ motId: route.params.motId }),
			meta: {
				breadcrumb() {
					return `RuleSetId: ${this.$route.params.motId}`;
				}
			},
			component: () =>
				import(/* webpackChunkName: "MOT.motId" */ "@/views/MOT/MOTDisplay")
		}
	]
};
